import React, { useMemo } from "react";
import usePathParams from "../../hooks/use-path-params";
import NotFound from "../NotFound";
import clxs from "./payment-status.module.css";
import GREEN_CHECKMARK_ICON from "../../assets/icons/green-checkmark.svg";
import RED_EXCLAIMATION_ICON from "../../assets/icons/exclamation-red-icon.svg";
import usePaymentStatus from "../../hooks/use-payment-status";
import useAnalytics from "../../hooks/use-analytics";
// import SCANNER_IMAGE from "../../assets/icons/scan-here.svg";
// import SCANNER_IMAGE_CIRCLE from "../../assets/icons/scan-here-cirlce.svg";
// import SCANNER_ICON from "../../assets/icons/scanner.svg";
// import useIsMobile from "../../hooks/use-is-mobile";
// import useIsIosMobile from "../../hooks/use-is-ios-mobile";
// import useEnv from "../../hooks/use-env";

function PaymentStatus() {
  const paymentId = usePathParams(PATH, "payment_id"),
    { objPaymentStatus } = usePaymentStatus(paymentId),
    { track } = useAnalytics(),
    // { isMobile } = useIsMobile(),
    // {isIosMobile} = useIsIosMobile(),
    // { APP_APP_STORE_URL, APP_PLAY_STORE_URL } = useEnv(),
    // storeUrl = isIosMobile
    //  ? APP_APP_STORE_URL
    //  : APP_PLAY_STORE_URL,
    description = useMemo(
      () => {
        if (!objPaymentStatus) {
          return null;
        }

        const {
            amount,
            paymentStatus,
          } = objPaymentStatus,
          isPaymentSuccess = paymentStatus == "success",
          currency_symbol = "₹";

          if(isPaymentSuccess) {
            const trackingPayload = localStorage.getItem("trackingPayload");
            track("payment_success", trackingPayload ? JSON.parse(trackingPayload) : {});
          }

        return isPaymentSuccess ? (
          <>
            <div className={clxs.thankYou}>
              {`Thank you, ${objPaymentStatus.name}.`}
            </div>
            <div className={clxs.successMessage}>
              {"Your payment of "}<b>{`${currency_symbol} ${amount?.toLocaleString("en-IN")}`}</b>{" was successful."}
              <br/>
            </div>
          </>
        ) : (
          <>
            <div className={clxs.thankYou}>
              {`Oops! ${objPaymentStatus.name}.`}
            </div>
            <div className={clxs.failMessage}>
              {"Your payment of "}<b>{`${currency_symbol} ${amount?.toLocaleString("en-IN")}`}</b>{" was unsuccessful."}
              <br/>
          </div>
          </>
        );
      },
      [objPaymentStatus],
    );

  if (!paymentId) {
    return <NotFound/>;
  }

  if (!objPaymentStatus) {
    return null;
  }

  return (
    <div className={clxs.container}>
      <img
        src={objPaymentStatus.paymentStatus == "success" ? GREEN_CHECKMARK_ICON : RED_EXCLAIMATION_ICON}
        alt="success"
        className={clxs.checkmark}
      />
      {description}
      {/* <div className={clxs.contentContainer}>
        <img
          src={isMobile ? SCANNER_IMAGE_CIRCLE : SCANNER_IMAGE}
          alt="success"
          className={clxs.scannerImage}
        />
        <div className={clxs.downloadText}>Download the Lohono Stays app <span className={clxs.downloadSubText}>and plan your meals in advance!</span></div>
        <div className={clxs.scannerContainer}>
        {isMobile ? null :
        <img
          src={SCANNER_ICON}
          alt="success"
          className={clxs.scanner}
        />}
         <div className={clxs.scanContent}>
         {isMobile ?null : <div className={clxs.scannerTitle}>Scan to download</div>}
         <div className={clxs.scannerSubTitle}>iOS and Android</div>
         {isMobile? 
           <div 
             className={clxs.downloadButton}
             onClick={(e) => {
              e.preventDefault();
              window.open(storeUrl, "_blank");
            }}
           >Download now</div> : null}
         </div>
        </div>
      </div> */}
    </div>
  );
}

export default PaymentStatus;

const PATH = "/payment-status/:payment_id";

